<template>
  <div class="user-authentication-modal">
    <el-dialog :title="$t('system.user_authentication')" :close-on-click-modal="false" class="diglog-card"
               :visible.sync="dialogVisible" width="500px" @close="initData">
      <div class="header-line"/>
      <div style="width: 420px; font-style: normal;font-weight: 400;font-size: 18px;line-height: 22px;color: #4B5567;">
        <p>{{ $t('tips.MFA_verification_code_authenticate_user_access') }}</p>
      </div>
      <el-form ref="form" :model="form" :rules="rules" style="margin-top: 30px">
        <el-form-item prop="code">
          <el-input v-model="form.code" placeholder="Enter your MFA verification code" class="search-frame"
                    autocomplete="off" clearable/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="onClickSubmitBtn">{{
            $t('components.submit')
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { authenticateMfa } from '@/api/merchant-manage/merchant-manage'
export default {
  name: 'MerchantAppModal',
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      dialogVisible: false,
      listLoading: false,
      form: {
        code: ''
      },
      rules: {
        code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    initData() {
      this.form = {
        code: ''
      }
      this.$nextTick(function () {
        this.$refs['form'].clearValidate()
      })
    },
    changModalStatus(value) {
      this.dialogVisible = value
    },
    onClickSubmitBtn() {
      const params = {
        verify: 1,
        code: this.form.code
      }
      authenticateMfa(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.dialogVisible = false
          this.$emit('closeMFA', this.rowData);
        }
      }).finally(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.user-authentication-modal {
  .el-dialog__body {
    padding: 30px 20px 0;
  }
  .el-input--medium .el-input__inner {
    height: 45px;
    line-height: 45px;
  }
}
</style>

<style lang="scss" scoped>
.search-frame {
  width: 420px;
}

.el-dialog__header {
  justify-content: flex-start;
}
</style>
